module.exports = __webpack_public_path__ + "static/media/item-8.28b2ec1c.jpeg";